var map = {
	"./comment_controller.js": 9,
	"./draft_controller.js": 10,
	"./followunfollow_controller.js": 11,
	"./hello_controller.js": 39,
	"./listpoliciesfilter_controller.js": 12,
	"./pagy_controller.js": 13,
	"./searchglossary_controller.js": 14,
	"./seenunseen_controller.js": 15,
	"./select_controller.js": 16,
	"./selectprofile_controller.js": 17,
	"./sidebar_controller.js": 18,
	"./tagpolicycategory_controller.js": 19,
	"./tagpolicyfamily_controller.js": 20,
	"./tagpolicytype_controller.js": 21,
	"./tagschildpolicy_controller.js": 22,
	"./tagscountry_controller.js": 23,
	"./tagsextratag_controller.js": 24,
	"./tagsparentpolicy_controller.js": 25,
	"./tagspoltype_controller.js": 26,
	"./tagssector_controller.js": 27,
	"./tagssubject_controller.js": 28,
	"./tagssupersededpolicy_controller.js": 29,
	"./tagssupersedespolicy_controller.js": 30,
	"./tagstech_controller.js": 31
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8;